const sections = document.querySelectorAll(".marquu_sec");
console.log(sections);
[...sections].forEach((section) => {
  const checkbox = section.querySelector("input");
  section.classList.toggle("enable-animation");
  
});

$('.product-media-modal__content').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true, // Enable adaptive height by default
  responsive: [
    {
      breakpoint: 640,
      settings: {
        adaptiveHeight: false,
         speed: 0,
        cssEase: 'linear'  
      }
    }
  ]
});

$(document).on('click','.main-pro-slider',function() {
  var imageslick_index = $(this).data('slick-index');
  console.log('imageslick_index = '+imageslick_index);
  $('.product-media-modal__content').slick('slickGoTo', imageslick_index);
});

// if($(window).width() < 767){
// $('.media-type-video span.product__media-icon.motion-reduce').click(function(e){
//     e.preventDefault();
//  $('span.deferred-media__poster-button.motion-reduce').click();
// });
// }